module.exports = __webpack_public_path__ + "img/focaccia.adda6f03.jpg";